import { render, staticRenderFns } from "./ExternalPaymentBrowserBack.vue?vue&type=template&id=6881a146&"
import script from "./ExternalPaymentBrowserBack.vue?vue&type=script&lang=ts&"
export * from "./ExternalPaymentBrowserBack.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports